// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.3.0 (commit ).

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  AlgebraicType,
  AlgebraicValue,
  BinaryReader,
  BinaryWriter,
  ConnectionId,
  DbConnectionBuilder,
  DbConnectionImpl,
  Identity,
  ProductType,
  ProductTypeElement,
  SubscriptionBuilderImpl,
  SumType,
  SumTypeVariant,
  TableCache,
  TimeDuration,
  Timestamp,
  deepEqual,
  type CallReducerFlags,
  type DbContext,
  type ErrorContextInterface,
  type Event,
  type EventContextInterface,
  type ReducerEventContextInterface,
  type SubscriptionEventContextInterface,
} from "@clockworklabs/spacetimedb-sdk";
export type SetFog = {
  x: number,
  y: number,
  w: number,
  h: number,
  kind: string,
};

/**
 * A namespace for generated helper functions.
 */
export namespace SetFog {
  /**
  * A function which returns this type represented as an AlgebraicType.
  * This function is derived from the AlgebraicType used to generate this type.
  */
  export function getTypeScriptAlgebraicType(): AlgebraicType {
    return AlgebraicType.createProductType([
      new ProductTypeElement("x", AlgebraicType.createI32Type()),
      new ProductTypeElement("y", AlgebraicType.createI32Type()),
      new ProductTypeElement("w", AlgebraicType.createI32Type()),
      new ProductTypeElement("h", AlgebraicType.createI32Type()),
      new ProductTypeElement("kind", AlgebraicType.createStringType()),
    ]);
  }

  export function serialize(writer: BinaryWriter, value: SetFog): void {
    SetFog.getTypeScriptAlgebraicType().serialize(writer, value);
  }

  export function deserialize(reader: BinaryReader): SetFog {
    return SetFog.getTypeScriptAlgebraicType().deserialize(reader);
  }

}


